// tslint:disable: max-line-length
import axios from 'axios';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import axiosInstance from '../../helpers/interceptor';

export const getAssessmentSeries = async (parentId) => {
    const { selectedHotel } = userHotelDetails();
    let dataD: any = [];
    const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/latest/${parentId}?&pageSize=2000&page=1&sort=-stayStart&hotelId=${selectedHotel}&isClientApp=true`);
    dataD = data;

    return dataD;
};
export const sendSelfAssessment = async (Ids) => {
    const {userData} = userHotelDetails();

    const { data } = await axios.post(`${Env.API_URL}/customerAssessment/sendAssessment`, {
        assessmentIds: Ids,
    } , {
        headers: {
            Authorization : `Bearer ${userData.accessToken}`,
        },
    });

    return data;
};
